var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.854 1031.69H328.854L514.125 810.875C480.959 775.896 434.042 754.083 382 754.083H200.042V966.625L307.209 838.917H381.209L200.042 1054.92V1118.08H382C482.542 1118.08 563.959 1036.58 563.959 936.125C563.959 908.812 557.959 882.979 547.146 859.687L402.854 1031.69Z",
    fill: "url(#paint0_linear_6_210)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M613.112 872.053H676.528C691.195 872.053 704.216 874.803 715.612 880.303C726.987 885.761 735.799 893.532 742.029 903.636C748.299 913.761 751.445 925.553 751.445 939.053C751.445 952.615 748.299 964.449 742.029 974.553C735.799 984.615 726.987 992.386 715.612 997.886C704.216 1003.39 691.195 1006.14 676.528 1006.14H613.112V872.053ZM675.028 975.886C686.466 975.886 695.653 972.636 702.612 966.136C709.612 959.595 713.112 950.553 713.112 939.053C713.112 927.553 709.612 918.553 702.612 912.053C695.653 905.553 686.466 902.303 675.028 902.303H651.028V975.886H675.028Z",
    fill: "url(#paint1_linear_6_210)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M904.078 976.803V1006.14H796.411V872.053H901.578V901.303H833.994V923.97H893.578V952.303H833.994V976.803H904.078Z",
    fill: "url(#paint2_linear_6_210)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.22 872.053L1028.8 1006.14H991.382L934.132 872.053H975.132L1011.55 959.386L1048.72 872.053H1086.22Z",
    fill: "url(#paint3_linear_6_210)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.44 976.053V1006.14H1115.27V982.386L1182.94 902.136H1117.02V872.053H1232.52V895.803L1164.94 976.053H1235.44Z",
    fill: "url(#paint4_linear_6_210)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1384.83 976.803V1006.14H1277.17V872.053H1382.33V901.303H1314.75V923.97H1374.33V952.303H1314.75V976.803H1384.83Z",
    fill: "url(#paint5_linear_6_210)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1489.56 970.47H1468.89V1006.14H1430.97V872.053H1492.31C1504.41 872.053 1514.93 874.095 1523.89 878.136C1532.83 882.136 1539.72 887.886 1544.56 895.386C1549.43 902.845 1551.89 911.595 1551.89 921.636C1551.89 931.365 1549.6 939.845 1545.06 947.053C1540.49 954.282 1534.01 959.928 1525.64 963.97L1554.56 1006.14H1513.89L1489.56 970.47ZM1513.56 921.636C1513.56 915.365 1511.56 910.511 1507.56 907.053C1503.6 903.615 1497.74 901.886 1489.97 901.886H1468.89V941.22H1489.97C1497.74 941.22 1503.6 939.532 1507.56 936.136C1511.56 932.761 1513.56 927.928 1513.56 921.636Z",
    fill: "url(#paint6_linear_6_210)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1669.63 958.053V1006.14H1631.72V957.47L1580.55 872.053H1620.63L1652.38 925.303L1684.22 872.053H1720.97L1669.63 958.053Z",
    fill: "url(#paint7_linear_6_210)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_210",
    x1: 200,
    y1: 936,
    x2: 1516.55,
    y2: 851.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F257A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C004D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_210",
    x1: 200,
    y1: 936,
    x2: 1516.55,
    y2: 851.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F257A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C004D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_210",
    x1: 200,
    y1: 936,
    x2: 1516.55,
    y2: 851.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F257A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C004D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_210",
    x1: 200,
    y1: 936,
    x2: 1516.55,
    y2: 851.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F257A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C004D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_210",
    x1: 200,
    y1: 936,
    x2: 1516.55,
    y2: 851.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F257A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C004D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_210",
    x1: 200,
    y1: 936,
    x2: 1516.55,
    y2: 851.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F257A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C004D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_210",
    x1: 200,
    y1: 936,
    x2: 1516.55,
    y2: 851.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F257A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C004D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_210",
    x1: 200,
    y1: 936,
    x2: 1516.55,
    y2: 851.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F257A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C004D9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ac37299e3b9de2984cc12b0169d857f1.svg";
export { ForwardRef as ReactComponent };